export { TransmissionIcon } from './transmission'
